export const directions_ru = [
    {
        id: "xqLFLSHGbf",
        type: "header",
        data: {
            text: "Направления",
            level: 3,
        },
    },
    {
        id: "8Kv9LFnFXo",
        type: "paragraph",
        data: {
            text: "<b>Мы, безусловно, не ограничиваем тебя в выборе темы. Но на всякий случай подготовили для тебя шпаргалку по направлениям:</b>",
        },
    },
    {
        id: "mYa3XK3rRb",
        type: "list",
        data: {
            style: "unordered",
            items: [
                "Медиаграмотность, фактчекинг, цифровая гигиена.&nbsp;<br>",
                "Гражданская активность, участие в политических процессах и права человека.",
                "Равный доступ к благам, феминизм, образование.",
                "Экология, загрязнение окружающей среды.&nbsp;",
            ],
        },
    },
    {
        id: "BS_eoRKWm1",
        type: "paragraph",
        data: {
            text: "Твой проект не подходит под эти направления? Не беда! В любом случае пройди регистрацию, шанс есть!&nbsp;",
        },
    },
];

export const directions_kg = [
    {
        id: "PHL204uni5",
        type: "header",
        data: {
            text: "Багыттар",
            level: 3,
        },
    },
    {
        id: "osw86Q1mF8",
        type: "paragraph",
        data: {
            text: "Биз, албетте, сизди тема тандоодо чектебейбиз. Бирок ыңгайлуулук кылуу максатында багыттар жөнүндө кыска маалымат бере кетели:",
        },
    },
    {
        id: "lVUSbDUZXg",
        type: "list",
        data: {
            style: "unordered",
            items: [
                "Медиа сабаттуулук, фактчекинг, санариптик гигиена.",
                "Жарандык активизм, саясий процесстерде катышуу жана адам укуктары.",
                "Татыктуу жашоого болгон жеткиликтүүлүктүн теңдиги, феминизм, билим берүү.",
                "Экология, айлана-чөйрөнүн кирлениши.",
            ],
        },
    },
    {
        id: "u7zUCLzB-U",
        type: "paragraph",
        data: {
            text: "Сиздин долбооруңуз бул багыттарга тиешелүү эмеспи? Эч нерсе эмес! Баары бир каттоодон өтүңүз, шанс бар!",
        },
    },
];
